<div class="title" #title>
  <div class="container container-max-width" style="display: flex; justify-content: space-between; align-items: flex-start;">
    <div style="flex: 1; min-width: 0;">
      <h4>{{ this.tableName + " Table View" }}</h4>
      <p>Please select the table name</p>
      <label class="col-md-9">
      <ng-select
        name="tableName"
        [(ngModel)]="tableItem"
        [items]="tableList"
        bindLabel="TableName"
        placeholder="Please choose one table"
        (change)="onTableChanged()"
        required
      >
        <ng-template ng-option-tmp let-item="item">
          <ng-container>
            <label title="{{ item.TableName }}">
              {{ item.TableTitle }}
            </label>
          </ng-container>
        </ng-template>
      </ng-select>
      </label>
    </div>
    <div *ngIf="isAdmin" style="display: flex; align-items: center; padding-top: 10px;">
      <button
        type="button"
        [class]="isEditMode ? 'btn btn-danger' : 'btn btn-primary'"
        (click)="toggleEditMode()"
      >
        {{ isEditMode ? 'Exit Edit Mode' : 'Edit Mode' }}
      </button>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <div>
      <p *ngIf="message" class="message">{{ this.message }}</p>
    </div>
    <br />
    <div class="hint">
      <label>{{ this.rowData.length }} row(s)</label>
      <a
        href="javascript:void(0)"
        class="topbar-item"
        (click)="exportExcel()"
        container="body"
        ngbTooltip="Export to Excel"
        aria-label="Export to Excel"
      >
        <span class="far fa-file-excel fa-lg"></span>
      </a>
      <div class="nofloat">
        <a href="javascript:void(0)" class="topbar-item" (click)="refreshData()" container="body"> Refresh </a>
        &nbsp;&nbsp;
        <a *ngIf="addRowEnable" href="javascript:void(0)" class="topbar-item" (click)="addRow()" container="body"> Insert Row </a>
        &nbsp;&nbsp;
        <a *ngIf="selectedRowsCount === 1 && editRowEnable" href="javascript:void(0)" class="topbar-item" (click)="editRow()" container="body"> Edit Row </a>
        &nbsp;&nbsp;
        <a
          *ngIf="selectedRowsCount === 1 && deleteRowEnable"
          href="javascript:void(0)"
          class="topbar-item"
          (click)="deleteRow()"
          container="body"
        >
          Delete Row
        </a>
      </div>
    </div>

    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <form #operatorForm="ngForm" autocomplete="off" novalidate>
      <div class="nofloat">
        <ag-grid-angular
          style="height: 540px"
          class="ag-theme-balham"
          [gridOptions]="gridOptions"
          [rowData]="rowData"
          [excelStyles]="headerStyle"
          [masterDetail]="true"
          [detailRowHeight]="145"
          [pagination]="true"
          (gridReady)="onGridReady($event)"
          (selectionChanged)="onSelectionChanged($event)"
          (rowClicked)="onRowClicked($event)"
          (dblclick)="editRow()"
          (filterChanged)="onFilterChanged($event)"
        >
        </ag-grid-angular>
      </div>
    </form>
    <div>
      &nbsp;&nbsp;
      <p *ngIf="selectedRowsCount === 0 && editRowEnable">* Use Insert Row to create a row. Double click or select a single row to start editing. Select a single row to enable delete.</p>
    </div>
  </div>
</div>
  